import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PrwcOutlinedButton from "../../../ui/widgets/custom/buttons/PrwcOutlinedButton";
import { OperationType } from "../../models/enums/home-generic.enums";
import ProfilePrimaryContact from "../../presentations/ProfilePrimaryContact";

const ProfilePrimaryContactContainer = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState(OperationType.READ);
  const [formData, setFormData] = useState(null);

  const handleOnSave = (data: any) => {
    setFormData(data);
    setMode(OperationType.READ);
  };

  const handleOnCancel = () => {
    setMode(OperationType.READ);
  };

  const handleOnEdit = () => {
    setMode(OperationType.EDIT);
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-2 font-semibold text-gray-700">
          {t("profileSummary.label.primaryContact")}
        </div>
        {mode === OperationType.READ ? (
          <div>
            <PrwcOutlinedButton
              onClick={handleOnEdit}
              labelKey="generic.action.edit"
              className="p-button-outlined p-button-sm"
            ></PrwcOutlinedButton>
          </div>
        ) : null}
      </div>
      <div>
        <ProfilePrimaryContact
          mode={mode}
          onSave={handleOnSave}
          onCancel={handleOnCancel}
          data={formData}
        ></ProfilePrimaryContact>
      </div>
    </div>
  );
};

export default ProfilePrimaryContactContainer;
